<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Adjust Default Estimation Parameters</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form
          class="modal-card-body" 
          :valid.sync="valid">
          <div 
            v-if="paramsLoading" 
            class="is-relative">
            <v-spin-loader :value="true">
              <div class="py-6"></div>
            </v-spin-loader>
          </div>
          <template v-else>
            <div 
              class="columns is-multiline title is-5"
              v-for="(section, i) in params" 
              :key="section.name">
              <div class="column is-full">
                <span>{{ section.name }}</span>
              </div>
              <div  
                v-for="param in section.fields"
                :key="param" 
                class="column is-half">
                <label class="label capitalize">
                  {{ param.replaceAll("_", " ") }}*
                </label>
                <v-text-field 
                  required
                  :placeholder="`Enter ${param.replaceAll('_', ' ')}`"
                  type="number"
                  v-model="estimationParams[param]"
                  @input="updateParam(param, $event)">
                </v-text-field>
              </div>
              <div class="column is-full">
                <hr class="my-2" v-if="i != params.length - 1">
              </div>
            </div>
          </template>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="saveChanges()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import VSpinLoader from '@/components/base/VSpinLoader'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VSpinLoader },
  data() {
    return {
      valid: true,
      params: [
        {
          name: 'Solar Power Calculation Parameters',
          fields: [
            "cell_width", "cell_distance", "string_distance",
            "side_margin", "top_margin", "bottom_margin", "top_busbar_space",
            "bottom_busbar_space", "busbar_thickness", "open_circuit_voltage",
            "energy_ratio"
          ]
        },
        {
          name: 'Battery Default Values',
          fields: [
            "batteries_system_size_kw", "batteries_and_invertors_val"
          ]
        },
        {
          name: 'Item Market Value',
          fields: [
            "solar_wall_active_val", "solar_wall_nonactive_val",
            "cladding_val", "railing_1100_1400_val", "irregular_val"
          ]
        },
        {
          name: 'Electricity Pricing',
          fields: [
            "elec_for_mitrex", "elec_for_mitrex_dpa", "elec_for_owner", 
            "elec_for_owner_dpa", "elec_price", "customer_share", "mitrex_margin"
          ]
        },
        {
          name: 'Environmental Impact Default Values',
          fields: [
            "sunlight_n", "sunlight_s", "sunlight_e", "sunlight_w",
            "sunlight_ne", "sunlight_se", "sunlight_nw", "sunlight_sw",
            "elec_homes_ratio", "cars_per_year_ratio", "metric_tones_co2_ratio",
            "no_of_trees_ratio"
          ]
        },
        {
          name: 'Tax Incentive Default Values',
          fields: [
            "alternative_material_cost_wall", "alternative_material_cost_railing",
            "cap_rate", "tax_rate", "dep_time", "maintenance_cost_wall",
            "maintenance_cost_railing"
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState("estimations", 
      ["estimationParams", "paramsLoading"]
    )
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("estimations", [
      "getEstimationParams", "updateEstimationParams", 
    ]),
    ...mapMutations("estimations", [
      "updateParam"
    ]),
    initialize() {
      this.getEstimationParams();
    },
    saveChanges() {
      this.updateEstimationParams(this.estimationParams).then(() => {
        this.close();
      })
    },
    close() {
      this.getEstimationParams();
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
